<template>
  <div>
    <v-layout class="mt-5 mb-2">
      <v-flex xs2 class="mr-3">
        <v-select
          v-model="buscarSelect"
          :items="buscaOptions"
          label="Tipo de busca"
          outlined
          menu-props="offsetY"
        ></v-select>
      </v-flex>
      <v-flex xs6>
        <v-autocomplete
          v-model="searchSelected"
          :items="buscaRegistros"
          item-value="identificadorusuariodepositomerenda"
          :hide-no-data="!search && buscaRegistros.length == 0 && !buscarLoading"
          :no-data-text="buscarLoading ? 'Carregando dados, aguarde...' : `Nenhuma opção encontrada com '${search}'`"
          outlined
          label="Buscar por"
          placeholder="Digite um valor para buscar"
          prepend-inner-icon="search"
          :search-input.sync="search"
          :filter="(item, queryText, itemText) => itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1"
          @keydown="buscar()"
          :loading="buscarLoading"
          @change="encontrado"
          :disabled="(acao == 'novo' || acao == 'editar')"
          :background-color="(acao == 'novo' || acao == 'editar') ? '#f2f2f2' : null">
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadorusuariodepositomerenda"
      :novo="novoUsuarioDeposito"
      :editar="editarUsuarioDeposito"
      :excluir="excluirUsuarioDeposito"
      :cancelar="cancelarUsuarioDeposito"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaUsuarioDeposito" :disabled="loading">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <v-row no-gutters>
            <v-col  lg="6">
              <v-text-field  label="Código Usuário/Depósito" v-model="form.identificadorusuariodepositomerenda" outlined disabled background-color="#f2f2f2"></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadorescolalocalexterno">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorescolalocalexterno"
                  :items="unidadeEscolarOptions"
                  item-text="nomeescola"
                  item-value="identificadorescolalocalexterno"
                  outlined
                  :disabled="isFormDisabled || acao == 'editar'"
                  :background-color="isFormDisabled || acao == 'editar' ? '#f2f2f2' : null"
                  label="Unidade Escolar*"
                  :no-data-text="unidadeEscolarLoading ? 'Carregando dados, aguarde...' : unidadeEscolarSearch ? `Nenhuma opção encontrada com '${unidadeEscolarSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="unidadeEscolarSearch"
                  :loading="unidadeEscolarLoading"
                  loader-height="3"
                  @focus="loadUnidadeEscolarOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.cdpessoal">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="funcionario"
                  :items="funcionariosOptions"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="Funcionário*"
                  :no-data-text="funcionariosLoading ? 'Carregando dados, aguarde...' : funcionarioSearch ? `Nenhuma opção encontrada com '${funcionarioSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="funcionarioSearch"
                  :disabled="isFormDisabled || acao == 'editar'"
                  :background-color="isFormDisabled || acao == 'editar' ? '#f2f2f2' : null"
                  :loading="funcionariosLoading"
                  loader-height="3"
                  :filter="filterData"
                  @keydown="handleFuncionarioSearch">
                  <template v-slot:item="{ item }">
                    {{item.value}}: {{item.text}}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{item.value}}: {{item.text}}
                  </template>
                </v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.identificadorperfil">
                <v-autocomplete
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.identificadorperfil"
                  :items="perfisOptions"
                  item-text="nomeperfil"
                  item-value="identificadorperfil"
                  outlined
                  :disabled="acao == '' || acao == 'excluir'"
                  :background-color="acao == '' || acao == 'excluir' ? '#f2f2f2' : null"
                  label="Perfil de Acesso*"
                  :no-data-text="perfilLoading ? 'Carregando dados, aguarde...' : perfilSearch ? `Nenhuma opção encontrada com '${perfilSearch}'` : 'Nenhuma opção carregada'"
                  :search-input.sync="perfilSearch"
                  :loading="perfilLoading"
                  loader-height="3"
                  @focus="loadPerfisOptions"
                ></v-autocomplete>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.datainiciopermissao">
                <v-text-field v-mask="'##/##/####'"
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.datainiciopermissao"
                  label="Data Início da Permissão"
                  outlined
                  :disabled="acao == '' || acao == 'excluir'"
                  :background-color="acao == '' || acao == 'excluir' ? '#f2f2f2' : null">
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col lg="6">
              <Validate :v="$v.form.datafimpermissao">
                <v-text-field v-mask="'##/##/####'"
                  slot-scope="{ props }"
                  v-bind="props"
                  v-model="form.datafimpermissao"
                  label="Data Fim da Permissão"
                  outlined
                  :disabled="acao == '' || acao == 'excluir'"
                  :background-color="acao == '' || acao == 'excluir' ? '#f2f2f2' : null">
                </v-text-field>
              </Validate>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import autocomplete from '../../utils/autocomplete'
import { IDENTIFICADOR_PERFIL_DIRETOR } from '../../utils/constants.js';
import { mapGetters } from 'vuex';
import { required, integer, alphaNum, helpers } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const EscolaRepository = RepositoryFactory.get("escola");
const UsuarioDepositoRepository = RepositoryFactory.get("usuarioDepositoRepository");
const FuncionariosRepository = RepositoryFactory.get('funcionariosRepository');
const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");
import moment from 'moment';


export default {
  name: 'UsuarioDeposito',
  data() {
    return {
      filterData: autocomplete.filterData,
      items: [],
      acao: '',
      form: this.setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      searchSelected: '',
      buscaRegistros: [],
      search: '',





      buscarSelect: 'nomeusuario',
      buscaOptions: [
        { value: 'nomeusuario', text: 'Nome do usuário' },
      ],
      textoBusca: '',
      funcionariosLoading: false,
      buscarLoading: false,
      funcionarioSearch: '',
      funcionariosOptions: [],
      funcionarioFoiCarregado: false,
      formUltimo: {},
      searchBusca: '',
      listaOptions: [],
      loading: false,
      IDENTIFICADOR_PERFIL_DIRETOR: IDENTIFICADOR_PERFIL_DIRETOR,
      unidadeEscolarOptions: [],
      unidadeEscolarLoading: false,
      unidadeEscolarSearch: '',
      unidadeEscolarFoiCarregado: false,
      perfisOptions: [],
      perfilLoading: false,
      perfilSearch: '',
      perfisFoiCarregado: false,
    };
  },
  computed: {
    ...mapGetters(['school', 'userDadosPerfilAtual']),
    isFormDisabled() {
      return this.acao == '' || this.acao == 'excluir'
    },
    funcionario: {
      get() {
        return this.form.cdpessoal && this.form.cdmatric ? `${this.form.cdpessoal}-${this.form.cdmatric}` : '';
      },
      set(value) {
        if (!value) {
          this.form.cdpessoal = '';
          this.form.cdmatric = '';
          return;
        }
        else
        [this.form.cdpessoal, this.form.cdmatric] = value.split('-');
      }
    },
  },
  validations: {
    form: {
      identificadorperfil: { required, integer },
      cdpessoal: { required, integer },
      cdmatric: { required, integer },
      datainiciopermissao: {
        required,
        isValidDate: function(campo, valor) { return valor.datainiciopermissao.length == 10 && moment(valor.datainiciopermissao, 'DD/MM/YYYY').isValid() },
        before: function (campo, valor) {
          return helpers.withParams({type: 'before', data: valor.datafimpermissao }, (value) => {
            return valor.datafimpermissao == null || valor.datafimpermissao.length < 10 || !moment(valor.datafimpermissao, 'DD/MM/YYYY').isValid() || (valor.datafimpermissao.length == 10 && moment(valor.datafimpermissao, 'DD/MM/YYYY').isValid() && moment(campo, 'DD/MM/YYYY').isSameOrBefore(valor.datafimpermissao, 'DD/MM/YYYY') )
          })();
        },
      },
      datafimpermissao: {
        isValidDate: function(campo, valor) { return campo == null || campo.trim() == '' || ( campo.length == 10 && moment(campo, 'DD/MM/YYYY').isValid()) },
      },
      identificadorescolalocalexterno: { required, alphaNum },
    }
  },
  async mounted() {
    this.$Progress.finish();
  },
  methods: {
    async loadUnidadeEscolarOptions() {
      if (this.unidadeEscolarOptions.length && this.unidadeEscolarFoiCarregado) {
        return
      }

      this.unidadeEscolarLoading = true
      this.unidadeEscolarOptions = [];
      const { data } = await CardapioEscolaRepository.recebeMerenda();
      for (const key of data.results) {
        this.unidadeEscolarOptions.push({ identificadorescolalocalexterno: key.identificadorescolalocalexterno, nomeescola: key.identificadorescolalocalexterno.slice(0, -1) + ' - ' + key.nomeescola })
      }
      this.unidadeEscolarLoading = false
      this.unidadeEscolarFoiCarregado = true;
    },
    async loadPerfisOptions() {
      if (this.perfisOptions.length && this.perfisFoiCarregado) {
        return
      }

      this.perfilLoading = true
      this.perfisOptions = [];
      const { data } = await UsuarioDepositoRepository.getPerfisModuloMerenda(this.userDadosPerfilAtual.identificadorperfil)
      this.perfisOptions = data.results
      this.perfilLoading = false
      this.perfisFoiCarregado = true;
    },
    setFormInicial() {
      this.escolaOptions = []
      this.funcionariosOptions = []
      return ({
        identificadorusuariodepositomerenda: '',
        cdpessoal: '',
        cdmatric: '',
        identificadorperfil: '',
        datainiciopermissao: '',
        datafimpermissao: '',
        identificadorescolalocalexterno: '',
      })
    },
    handleBusca() {
      const novoValor = this.searchBusca ?? ''
        if(novoValor.length < 3) return
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.listarRegistros()
                                                  }, 1000
                                    )
    },
    handleFuncionarioSearch() {
      const novoValor = this.funcionarioSearch ?? ''
      if(novoValor.length < 3) return
      clearTimeout(this._searchTimeId)
      this._searchTimeId = setTimeout(async () => {
                                                    await this.loadFuncionariosOptions()
                                                  }, 1000
                                    )
    },
    tabelaUsuarioDeposito() {
      const params = {
        titulo: 'Usuário e seus depósitos / Listar',
        rota_api: 'merenda/usuario-deposito/tabela',
        headers: [{ text: 'Identificador', value: 'identificadorusuariodepositomerenda', sortable: true },
                    { text: 'Matrícula', value: 'matricula', sortable: true, filtable: false },
                    { text: 'Nome Usuário', value: 'nomeusuario', sortable: true },
                    { text: 'Nome Escola', value: 'nomeescola', sortable: true, filtable: false },
                    { text: 'Data Início Permissão', value: 'datainiciopermissao', sortable: false, filtable: false },
                    { text: 'Data Fim Permissão', value: 'datafimpermissao', sortable: false, filtable: false },
                  ],
      }
      this.$root.$router.push({
        name: 'tabelas',
        params,
      });
    },
    async novoUsuarioDeposito() {
      this.acao = 'novo';
      this.form = this.setFormInicial();
      this.funcionarioSearch = '';
      this.$v.$reset();
    },
    editarUsuarioDeposito() {
      this.acao = 'editar';
    },
    async cancelarUsuarioDeposito() {
      if (this.acao == 'novo') {
        this.form = this.setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirUsuarioDeposito() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este usuário/depósito?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await UsuarioDepositoRepository.deletarUsuarioDeposito(this.form.identificadorusuariodepositomerenda);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = this.setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async onSubmit() {
      this.msgArrayError = [];
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await UsuarioDepositoRepository[this.acao === 'novo' ? 'criarUsuarioDeposito' : 'editarUsuarioDeposito'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.form = { ...data.results};
        this.formUltimo = { ...this.form };

      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    async encontrado(itemSelecionado) {
      this.form = this.setFormInicial();
      let dadosItemSelecionado = this.buscaRegistros.find(i => i.identificadorusuariodepositomerenda == itemSelecionado);
      this.form = {
        identificadorusuariodepositomerenda: dadosItemSelecionado.identificadorusuariodepositomerenda,
        cdpessoal: dadosItemSelecionado.cdpessoal,
        cdmatric: dadosItemSelecionado.cdmatric,
        identificadorperfil: dadosItemSelecionado.identificadorperfil,
        datainiciopermissao: dadosItemSelecionado.datainiciopermissao,
        datafimpermissao: dadosItemSelecionado.datafimpermissao ?? '',
        identificadorescolalocalexterno: dadosItemSelecionado.identificadorescolalocalexterno,
       };
      this.formUltimo = { ...this.form };
      if (this.unidadeEscolarOptions.length == 0) {
        this.unidadeEscolarOptions = [{ identificadorescolalocalexterno: dadosItemSelecionado.identificadorescolalocalexterno, nomeescola: dadosItemSelecionado.identificadorescolalocalexterno.slice(0, -1) + ' - ' + dadosItemSelecionado.nomeescola}];
      }
      if (this.funcionariosOptions.length == 0) {
        this.funcionariosOptions = [{ value: `${dadosItemSelecionado.cdpessoal}-${dadosItemSelecionado.cdmatric}`, text: dadosItemSelecionado.nmfuncion}];
      }
      if (!this.perfisFoiCarregado) {
        this.perfisOptions = [{
          identificadorperfil: dadosItemSelecionado.perfil.identificadorperfil,
          nomeperfil: dadosItemSelecionado.perfil.nomeperfil
        }];
      }

      this.$nextTick(() => {
        this.searchSelected = null;
        this.search = '';
      });
      this.acao = '';
    },
    async loadFuncionariosOptions() {
      try {
        if (this.funcionarioSearch === '') return
        this.funcionariosLoading = true
        this.funcionariosOptions = []
        const { data } = await FuncionariosRepository.buscarFuncionarioAtivoPorNome(this.funcionarioSearch);
        for (const key of data.results) {
          this.funcionariosOptions.push({ value: `${key.cdpessoal}-${key.cdmatric}`, text: key.nmfuncion })
        }

      } catch (error) {
        console.error(error)
      }
      finally {
        this.funcionariosLoading = false
      }

    },
    async listarRegistros() {
      try {
        this.buscarLoading = true

        const params = { nomeusuario: this.searchBusca }
        const { data } = await UsuarioDepositoRepository.buscarUsuarioDeposito(params)
        this.listaOptions = data.results
      } catch (error) {
        console.error(error)
      }
      finally {
        this.buscarLoading = false

      }
    },
    async buscar() {
      if (this.buscaRegistros.length || this.buscarLoading) return
      this.buscarLoading = true
      const { data } = await UsuarioDepositoRepository.buscarUsuarioDeposito({})
      for (const key of data.results) {
        this.buscaRegistros.push({...key, text: `${key.nmfuncion} - ${key.nomeescola} - ${key.perfil.nomeperfil}`,})
      }
      this.buscarLoading = false
    },
  },
};
</script>

<style>

</style>
